import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setInteractionPickerFilter } from "../../app/slices/InteractionPickerSlice";
import PiBrowseDialog from "../../components/PiBrowseDialog";
import Interaction from "../../models/interactions/Interaction";
import { InteractionDefintion } from "./InteractionDefinitions";
import InteractionPickerBody from "./InteractionPickerBody";

interface InteractionPickerProps {
  open: boolean;
  onClose: () => void;
  // when set, only these definitions are offered (e.g. quiz feedback subset)
  definitions?: InteractionDefintion[];
  // when set, the created interaction is handed here instead of the selected take
  onAddInteraction?: (interaction: Interaction) => void;
}

export default function InteractionPicker(props: InteractionPickerProps) {
  const { open, onClose, definitions, onAddInteraction } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) dispatch(setInteractionPickerFilter(""));
  }, [open, dispatch]);

  return (
    <PiBrowseDialog
      open={open}
      onClose={onClose}
      title={t("interaction_picker")}
      body={
        <InteractionPickerBody
          onClose={onClose}
          definitions={definitions}
          onAddInteraction={onAddInteraction}
        />
      }
    />
  );
}
